<form #f="ngForm">
    <div class="p-as-center p-mt-auto">
        <div class="p-grid">
            <div class="p-col-12 error-notify-text">
                <app-validateform #resetPasswordForm [formToValidate]="resetPasswordF"></app-validateform>
            </div>
        </div>
    </div>
    <div class="p-d-flex p-flex-column">
        <div class="p-as-center p-mb-auto">
            <div class="login-page pages-panel card">               
                <div class="input-panel">
                    <div class="p-ml-3 p-mr-3">
                        <div class="p-mb-4 p-mt-3" style="text-align:center !important"><h4>{{title}}</h4></div>
                        <div class="p-inputgroup">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-lock"></i>
                            </span>
                            <span class="p-float-label">
                                <p-password id="inputgroup"
                                            [(ngModel)]="password"
                                            [toggleMask]="true"
                                            name="Password"
                                            requiredNoSpaceValidator
                                            data-display-name="Password"
                                            [feedback]="false">
                                </p-password>
                                <label for="inputgroup">Password*</label>
                            </span>
                        </div>
                        <div class="p-inputgroup p-mt-3 p-mb-6">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-lock"></i>
                            </span>
                            <span class="p-float-label">
                                <p-password id="inputgroup"
                                            [(ngModel)]="passwordConfirm"
                                            name="ConfirmPassword"
                                            [feedback]="false"
                                            [toggleMask]="true">
                                </p-password>
                                <label for="inputgroup">Confirm Password*</label>
                            </span>
                        </div>
                        <button pButton (click)="resetPassword()" class="fullwidthbtn p-mb-2" label="RESET PASSWORD"></button>
                        <div *ngIf="requestNewLink">
                            <p-button styleClass="p-button-link" (click)="showRequestNewLink()" label="Request New Link"></p-button>
                        </div>
                        <div *ngIf="currentURL.includes('forgotpassword')">
                            <p-button styleClass="p-button-link" routerLink="/login" label="Return to Login"></p-button>
                        </div>
                    </div>                   
                </div>              
            </div>
        </div>        
    </div>
</form>

<form #f1="ngForm">
    <p-dialog draggable="false" modal="true"  styleClass="p-dialog-medium" header="Request New Link" [(visible)]="showRequestNewLinkDialog">
        <div class="p-col-12 error-notify-text">
            <app-validateform #requestNewLinkdForm [formToValidate]="requestNewLinkdF"></app-validateform>
        </div>
        <div class="input-panel p-d-flex p-flex-column p-px-3" style="margin-top: 20px;">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                    <i class="pi pi-user"></i>
                </span>
                <span class="p-float-label">
                    <input id="inputgroup"
                           [(ngModel)]="email"
                           name="email"
                           requiredNoSpaceValidator
                           emailValidator
                           data-display-name="email"
                           pInputText />
                    <label for="inputgroup">Email*</label>
                </span>
            </div>
        </div>
        <p-footer>
            <p-button label="SUBMIT" (click)="sendRequestNewLink()"></p-button>
        </p-footer>
    </p-dialog>
</form>
